import { Component, OnInit } from '@angular/core';
import { HttpService } from '../service/http.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AutofillService } from '../service/autofill.service';
import { PrimeToastService } from '../prime-toast.service';

@Component({
  selector: 'app-autofill-config',
  templateUrl: './autofill-config.component.html',
  styleUrls: ['./autofill-config.component.css']
})
export class AutofillConfigComponent implements OnInit {

  textBody: string = "";
  downloadUrl!: SafeResourceUrl;
  textFile: any;
  trustedUrl!: SafeResourceUrl;
  fileToUpload: any;
  textInput = "";

  inputB = "";
  output: string = "";

  constructor(
    private httpService: HttpService,
    private sanitizer: DomSanitizer,
    private autofillService: AutofillService,
    private toastService: PrimeToastService
  ) { }

  ngOnInit() {
    this.httpService.getCsvFile("f792d396-b809-4c3a-8050-fcec315c915b").subscribe(res => {
      this.textBody = res;
      this.textInput = res;
      this.createFile();
      this.downloadUrl = this.sanitizer.bypassSecurityTrustResourceUrl("data:application/octet-stream;charset=utf8,%EF%BB%BF" + encodeURI(this.textBody));
    });
  }

  createFile() {
    let data = new Blob([this.textBody], { type: 'text/plain' });
    this.textFile = window.URL.createObjectURL(data);
    this.trustedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.textFile);
  }

  handleFileInput(event: any) {
    if (event.target.files && event.target.files[0]) {
      let allowedTypes = ["text/plain", ""];
      if (allowedTypes.indexOf(event.target.files[0].type) == -1) {
        alert("wrong file type: " + event.target.files[0].name);
        return;
      }
    }
    let reader = new FileReader();
    reader.readAsText(event.target.files[0]);
    reader.onload = (event: any) => {
      this.textInput = event.target.result;
    }
  }

  sendFile() {
    let formData = new FormData();
    formData.append("file", this.fileToUpload);
    this.httpService.putCsvFile(formData, "f792d396-b809-4c3a-8050-fcec315c915b")
      .subscribe(() => {
        console.log("success");
        this.fileToUpload = null;
        this.toastService.addSuccess("Success", "Successfully updated from uploaded file");
      },
        error => {
          this.toastService.addError("Error", "Update failed");
        }
      );
  }

  sendTextInput() {
    let blob = new Blob([this.textInput], { type: "text/plain" });
    let file = new File([blob], "config.txt");
    console.log(file);
    let formData = new FormData();
    formData.append("file", file);
    this.httpService.putCsvFile(formData, "f792d396-b809-4c3a-8050-fcec315c915b")
      .subscribe(() => {
        console.log("success");
        this.fileToUpload = null;
        this.toastService.addSuccess("Success", "Successfully updated from text area");
      }, error => {
        this.toastService.addError("Error", "Update failed");
      });
  }

  separateString(input: string) {
    let profilesHeader = "### AUTOFILL PROFILES ###,,,,,,\nProfile ID,Name,Site,Hotkey,,,";
    let rulesHeader = "### AUTOFILL RULES ###,,,,,,\nRule ID,Type,Name,Value,Site,Mode,Profile";
    let optionsHeader = "### AUTOFILL OPTIONS ###,,,,,,";
    let firstPart = input.split(profilesHeader);
    let secondPart = firstPart[1].split(rulesHeader);
    let thirdPart = secondPart[1].split(optionsHeader);
    let result = [];
    result.push(secondPart[0].trim());
    result.push(secondPart[1].trim());
    result.push(thirdPart[1].trim());
    return result;
  }

  merge() {
    if (this.inputB == "" || this.textBody == "") {
      return;
    }
    console.log("merge method called");

    let success = false;
    try {
      let config = this.autofillService.stringToObject(this.textBody);
      let config2 = this.autofillService.stringToObject(this.inputB);
      let result = this.autofillService.merge(config, config2);
      this.output = this.autofillService.objectToString(result);
      success = true;
    }
    catch (error) {
      console.log("error happens");
      success = false;
      this.toastService.addError("Merge error", "Error. please check again the config text format.");
    }
    if (success) {
      this.toastService.addSuccess("Merge success", "Successfully merged");
    }

  }

}
